import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Button from '@mui/material/Button';
import topCardImage from '@/assets/images/landing/client-app/card-1-top-left.svg';
import middleCardImage from '@/assets/images/landing/client-app/card-2-middle-left.svg';
import bottomCardImage from '@/assets/images/landing/client-app/card-3-bottom-left.svg';
import phoneMockupImage from '@/assets/images/landing/client-app/phone-mockup-frame.svg';
import appStoreBadge from '@/assets/images/store-badges/app-store-badge.svg';
import googlePlayBadge from '@/assets/images/store-badges/google-play-badge.png';
import { COMPANION_APP_STORE_URL } from '@/data/companionAppSeo';
import styles from './ClientAppSection.module.css';

const ClientAppSection = () => {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <div className={styles.copy}>
          <h2>
            <span className={styles.headingLine}>The client app that</span>
            <br />
            <span className={styles.headingLine}>keeps things <em>moving</em></span>
          </h2>
          <p>
            Your clients don't juggle multiple tools. Everything lives in one intuitive app,
            plans, progress, questionnaires, and communication.
          </p>
          <Button
            component={RouterLink}
            to="/companion-app"
            variant="outlined"
            className={styles.knowMoreButton}
            data-analytics-event="Landing CTA Clicked"
            data-analytics-id="client_app_know_more"
            data-analytics-label="Know More"
            data-analytics-section="client_app"
          >
            Know More
          </Button>

          <div className={styles.storeRow}>
            <div className={styles.storeBadges}>
              <a
                href={COMPANION_APP_STORE_URL}
                target="_blank"
                rel="noreferrer"
                data-analytics-event="Landing CTA Clicked"
                data-analytics-id="client_app_apple"
                data-analytics-label="Download on the App Store"
                data-analytics-section="client_app"
              >
                <img src={appStoreBadge} alt="Download on the App Store" className={styles.storeBadgeApple} />
              </a>
              <div className={styles.storeBadgePending}>
                <img src={googlePlayBadge} alt="Google Play" className={styles.storeBadgeGoogle} />
                <span className={styles.storeRowLabel}>Android coming soon</span>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.visual} aria-label="Client app preview">
          <img src={phoneMockupImage} alt="" className={styles.phone} aria-hidden />

          <img src={topCardImage} alt="" className={`${styles.assetCard} ${styles.weightCard}`} aria-hidden />
          <img src={middleCardImage} alt="" className={`${styles.assetCard} ${styles.progressCard}`} aria-hidden />
          <img src={bottomCardImage} alt="" className={`${styles.assetCard} ${styles.calorieCard}`} aria-hidden />
        </div>
      </div>
    </section>
  );
};

export default ClientAppSection;
